import { render, staticRenderFns } from "./StandartWithoutEllipseBanner.vue?vue&type=template&id=33c5c754"
import script from "./StandartWithoutEllipseBanner.vue?vue&type=script&lang=js"
export * from "./StandartWithoutEllipseBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports